/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import {
    AppBar,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    Grid,
    TextField,
    Toolbar,
} from '@material-ui/core';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { esNumerico } from '@infotrack/utilitarios/expresionesRegulares';
import React from 'react';
import { IFormularioTipoContribuyenteVistaProps } from '../interfaces';

const FormularioTipoContribuyenteVista: React.FunctionComponent<IFormularioTipoContribuyenteVistaProps> = ({
    accionCrearEditar,
    cambiarInfoFomulario,
    cerrarFormulario,
    estadoFormulario,
    tipoContribuyente,
    tipoFormulario,
}) => (
    <Dialog open={estadoFormulario}>
        <AppBar position="static">
            <Toolbar>
                <Grid container justifyContent="center">
                    <Texto
                        align="center"
                        color="inherit"
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'tipoContribuyente.agregarTipoContribuyente'
                                : 'tipoContribuyente.modificarTipoContribuyente'
                        }
                    />
                </Grid>
            </Toolbar>
        </AppBar>
        <DialogContent>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="tipoContribuyente.codigoTipoContribuyente" display="inline" />}
                        inputProps={{ readOnly: tipoFormulario === TipoFormulario.Visualizacion }}
                        name="CodigoTipoContribuyente"
                        onChange={(e) => esNumerico(e.target.value, 8, false) && cambiarInfoFomulario(e)}
                        required
                        value={tipoContribuyente.CodigoTipoContribuyente}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="tipoContribuyente.nombreTipoContribuyente" display="inline" />}
                        inputProps={{ readOnly: tipoFormulario === TipoFormulario.Visualizacion }}
                        name="NombreTipoContribuyente"
                        onChange={cambiarInfoFomulario}
                        required
                        value={tipoContribuyente.NombreTipoContribuyente}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={tipoContribuyente.EstadoTipoContribuyente}
                                onChange={cambiarInfoFomulario}
                            />
                        }
                        label={<Texto id="tipoContribuyente.estadoTipoContribuyente" display="inline" />}
                        name="EstadoTipoContribuyente"
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <div>
                <Grid container justifyContent="flex-end" spacing={2}>
                    <Grid item>
                        <Button onClick={cerrarFormulario} color="secondary" variant="contained">
                            <Texto id="boton.cancelar" />
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button onClick={accionCrearEditar} color="primary" variant="contained">
                            <Texto id="boton.guardar" />
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </DialogActions>
    </Dialog>
);

export default FormularioTipoContribuyenteVista;
